import { identify, makeRequest, Service } from '../../../utils/http';

export async function getAllItemsApi() {
  return makeRequest(Service.getAllItems(99999, 0, await identify()));
}
